
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.032 4.453a.72.72 0 00-.502 1.236L8.341 9.5l-3.81 3.81a.72.72 0 101.018 1.019l3.81-3.81 3.812 3.81a.72.72 0 101.018-1.018L10.378 9.5l3.81-3.811a.72.72 0 10-1.018-1.018L9.36 8.48l-3.811-3.81a.72.72 0 00-.517-.218z","fill":"#122546"}})])
          )
        }
      }
    